import React from 'react';
import { AppContextType, withAppContext } from 'context/AppContext';
import { PrismicHTMLParser } from 'components/PrismicHTMLParser';
import { SliceContext } from 'components/Slices/types';

type ExternalLinkProps = {
    label?: string | null;
    link: {
        url: string;
        raw?: {
            target: '_blank' | null;
        };
        target?: '_blank' | null;
    };
    className?: string;
    children?: any;
    slice?: SliceContext;
    context?: AppContextType;
};

const ExternalLinkComponent = (props: ExternalLinkProps) => {
    /**
     * Sends the "Link Followed" event to Segment
     * @param {React.MouseEvent<HTMLAnchorElement>} event : the click event
     */
    const followLink = (event: React.MouseEvent<HTMLAnchorElement>): void => {
        const url = event.currentTarget.getAttribute('href') || '';
        const target = event.currentTarget.target;
        const segment = props.context && props.context.segment;

        if (!segment || !url) {
            return;
        }

        if (target && target === '_blank') {
            segment.trackLinkFollowed({ 'L - Destination Link': url }, props.slice);
        } else {
            event.preventDefault();
            segment.trackLinkFollowed({ 'L - Destination Link': url }, props.slice).then(() => {
                window.top.location.assign(url);
            });
        }
    };

    const { label, link, className, children } = props;

    return (
        <a
            href={link.url}
            target={link.target || (link.raw && link.raw.target) || undefined}
            rel="noopener"
            className={className}
            onClick={followLink}
            data-testid="link"
        >
            {label ? <PrismicHTMLParser data-testid="label">{label}</PrismicHTMLParser> : children}
        </a>
    );
};

const ExternalLink = withAppContext(ExternalLinkComponent);

export { ExternalLink, ExternalLinkComponent, ExternalLinkProps };
